import Controller from './Controller';

if ('serviceWorker' in navigator) {
	window.addEventListener('load', async () => {
		try {
			await navigator.serviceWorker.register('service-worker.js');
			console.log('Registered!');
		} catch (err) {
			console.log('ServiceWorker registration failed: ', err);
		}
	});
} else {
	console.warn('Service worker is not supported');
}

new Controller();
